import React, { Component } from 'react';
import { SView, SText, STheme } from 'servisofts-component2';
import Reload from "../../Assets/svg/reload.svg"

export default class Recargar extends Component {
    initialTime = 300; // segundos

    constructor(props) {
        super(props);
        this.state = {
            time: this.initialTime,
            rotate: false,
        };
        this.interval = null;
    }

    componentDidMount() {
        this.startTimer();
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    startTimer = () => {
        this.interval = setInterval(() => {
            this.setState(prev => {
                if (prev.time <= 1) {
                    clearInterval(this.interval);
                    this.setState({ time: this.initialTime, rotate: true }, () => {
                        setTimeout(() => this.setState({ rotate: false }), 1000);
                        if (this.props.onFinish) this.props.onFinish(); // ✅ ejecuta función del padre
                        this.startTimer(); // reinicia el contador
                    });
                    return { time: 0 };
                }
                return { time: prev.time - 1 };
            });
        }, 1000);
    };

    formatTime = (seconds) => {
        const min = Math.floor(seconds / 60);
        const sec = seconds % 60;
        return `${min}:${sec < 10 ? '0' : ''}${sec}`;
    };


    onPress = () => {
        clearInterval(this.interval);
        this.setState({ time: this.initialTime, rotate: true }, () => {
            setTimeout(() => this.setState({ rotate: false }), 1000);
            if (this.props.onFinish) this.props.onFinish(); // ✅ Ejecuta recargarPagina
            this.startTimer();
        });
    };

    render() {
        const { time, rotate } = this.state;
        return (
            <SView width={38} center height={38} onPress={this.onPress}>
                <Reload name={"Reload"} width={38} height={38} fill={STheme.color.text} style={{
                    transform: [{ rotate: rotate ? '120deg' : '0deg' }]
                }} />
                <SView col={"xs-12"} height={40} style={{ position: "absolute", paddingTop: 2 }} center>
                    <SText fontSize={8} style={{ color: STheme.color.text }}>{this.formatTime(time)}</SText>
                </SView>
            </SView>
        );
    }
}
